module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'search'
			],
			core: {
				check_callback: function(operation, node, node_parent, node_position, more) {
					var result = false;
					if(operation === 'move_node'){
						var treesComponent;
						if(more.origin.element && (treesComponent = getComponent($(more.origin.element).closest('.base_trees_trees')))){
							var nodeData = treesComponent.getNodeData(node.id);
							var parentNodeData;
							if(node_parent.id != '#') parentNodeData = treesComponent.getNodeData(node_parent.id);

							result = (
								// move banner to another client
								(
									nodeData.bannerID != undefined
									&&
									parentNodeData != undefined
									&&
									!parentNodeData.bannerID
									&&
									parentNodeData.clientID != undefined
								)
							);
						}
					}
					return result;
				}
			}
		}
	}
};
